export default __webpack_public_path__ + "static/media/check-1.a65c6ee4.svg";